<template>
    <div id="billing-wizard">
        <div class="stepper-slider" v-if="!disableCompleteButton">
            <Stepper :activeTab="activeIndex" @changeTab="(i) => (activeIndex = i)" :tabInfo="stepperData" />
            <div class="company-logo">
                <img src="https://supsis.com/wp-content/uploads/2024/04/supsis-logo.png" width="160" />
            </div>
        </div>
        <div class="setup">
            <div class="body">
                <div class="content">
                    <CustomerPlans
                        v-if="activeIndex === 0"
                        :is-wizard="true"
                        type="supsis"
                        :is-admin="false"
                        :plan-details="getPlanDetails('supsis')"
                        :active-plan="getActivePlan('supsis')"
                        :period="getPeriod('supsis')"
                        @subscribe="addSubscribe"
                        @unsubscribe="removeUnSubscribe"
                    />
                    <CustomerPlans
                        v-if="activeIndex === 1"
                        :is-wizard="true"
                        type="chatbot"
                        :is-admin="false"
                        :plan-details="getPlanDetails('chatbot')"
                        :active-plan="getActivePlan('chatbot')"
                        :period="getPeriod('chatbot')"
                        @subscribe="addSubscribe"
                        @unsubscribe="removeUnSubscribe"
                    />
                    <CustomerPlans
                        v-if="activeIndex === 2"
                        :is-wizard="true"
                        type="whatsapp"
                        :is-admin="false"
                        :plan-details="getPlanDetails('whatsapp')"
                        :active-plan="getActivePlan('whatsapp')"
                        :period="getPeriod('whatsapp')"
                        @subscribe="addSubscribe"
                        @unsubscribe="removeUnSubscribe"
                    />
                    <CustomerPlans
                        v-if="activeIndex === 3"
                        :is-wizard="true"
                        type="whatsapp-business"
                        :is-admin="false"
                        :plan-details="getPlanDetails('whatsapp-business')"
                        :active-plan="getActivePlan('whatsapp-business')"
                        :period="getPeriod('whatsapp-business')"
                        @subscribe="addSubscribe"
                        @unsubscribe="removeUnSubscribe"
                    />
                    <CustomerPlans
                        v-if="activeIndex === 4"
                        :is-wizard="true"
                        type="instagram"
                        :is-admin="false"
                        :plan-details="getPlanDetails('instagram')"
                        :active-plan="getActivePlan('instagram')"
                        :period="getPeriod('instagram')"
                        @subscribe="addSubscribe"
                        @unsubscribe="removeUnSubscribe"
                    />
                    <CustomerPlans
                        v-if="activeIndex === 5"
                        :is-wizard="true"
                        type="messenger"
                        :is-admin="false"
                        :plan-details="getPlanDetails('messenger')"
                        :active-plan="getActivePlan('messenger')"
                        :period="getPeriod('messenger')"
                        @subscribe="addSubscribe"
                        @unsubscribe="removeUnSubscribe"
                    />
                    <div class="preview" v-if="activeIndex === 6">
                        <SubscriptionCard
                            v-for="key of Object.keys(subscribes).filter((x) => subscribes[x].plan)"
                            :subscribe="subscribes[key]"
                            :details="subscribes[key].details || {}"
                            :key="key"
                            @deletePlan="deletePlan(subscribes[key].plan)"
                        />
                    </div>
                    <div class="stepper-buttons" v-if="activeIndex <= 6">
                        <div class="stepper-button" @click="activeIndex--" v-if="activeIndex !== 0">
                            {{ $t("wp.wpBack") }}
                        </div>
                        <div class="stepper-button" @click="activeIndex++">
                            {{ getNextButtonText() }}
                        </div>
                    </div>
                    <div class="payment" v-if="activeIndex === 7">
                        <div
                            style="
                                display: flex;
                                align-items: center;
                                flex-direction: column;
                                margin-bottom: 15px;
                                width: 100%;
                                gap: 20px;
                            "
                        >
                            <CreditCardForm
                                v-if="sitePaymentMethod === 'credit-card'"
                                @input="(val) => (cardForm = val)"
                            />
                            <BillingAddressForm
                                :user-agreement="userAgreement"
                                @input="(val) => (billingAddressForm = val)"
                                @userAgreementAccepted="(val) => (userAgreement = val)"
                            />
                        </div>
                        <div>
                            <TotalCost
                                :subscribes="subscribes"
                                @submit="complateWizard"
                                :disableCompleteButton="disableCompleteButton"
                            />
                        </div>
                    </div>
                    <PlanSelectionCompleted @clickHandler="goBillingPage()" v-if="activeIndex === 8" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Stepper from "../../../../../components/billing/new/Stepper.vue";
import ChangePlan from "../../../../../components/billing/new/ChangePlan.vue";
import Card from "../../../../../components/billing/Card.vue";
import SubscriptionCard from "../../../../../components/billing/new/SubscriptionCard.vue";
import CreditCardForm from "../../../../../components/billing/new/CreditCardForm.vue";
import BillingAddressForm from "../../../../../components/billing/new/BillingAddressForm.vue";
import TotalCost from "../../../../../components/billing/new/TotalCost.vue";
import PlanSelectionCompleted from "../../../../../components/billing/new/PlanSelectionCompleted.vue";
import { message } from "ant-design-vue";
import { mapActions, mapState } from "vuex";
import CustomerPlans from "./CustomerPlans.vue";
import { sendSocketMessage } from "../../../../../utils/socketStream";
import _ from "lodash";
import { calcDiscount, calcPrice, getProductQuantity } from "../../../../../components/billing/utils/PriceCalc";

const { updateBilling } = require("../../../../../api/billing");

export default {
    name: "BillingWizard",
    components: {
        CustomerPlans,
        Stepper,
        ChangePlan,
        Card,
        SubscriptionCard,
        CreditCardForm,
        BillingAddressForm,
        TotalCost,
        PlanSelectionCompleted,
    },
    data() {
        return {
            disableCompleteButton: false,
            subscribes: {
                supsis: {
                    icon: "CSupsis",
                    period: "monthly",
                    plan: null,
                    price: 0,
                    details: {
                        agentCount: 1,
                    },
                },
                chatbot: {
                    icon: "CChatbot",
                    period: "monthly",
                    plan: null,
                    price: 0,
                },
                instagram: {
                    icon: "Instagram",
                    period: "monthly",
                    plan: null,
                    price: 0,
                    details: {
                        instagramChannel: 1,
                    },
                },
                whatsapp: {
                    icon: "CWhatsapp",
                    period: "monthly",
                    plan: null,
                    price: 0,
                    details: {
                        whatsappChannel: 1,
                    },
                },
                "whatsapp-business": {
                    icon: "CWhatsappBusiness",
                    period: "monthly",
                    plan: null,
                    price: 0,
                    details: {
                        whatsappChannel: 1,
                    },
                },
                messenger: {
                    icon: "Messenger",
                    period: "monthly",
                    plan: null,
                    price: 0,
                    details: {
                        messengerChannel: 1,
                    },
                },
            },
            cardForm: null,
            billingAddressForm: null,
            activeIndex: 0,
            stepperData: [
                {
                    logo: "SelectPlan",
                    title: "Live Support",
                    isSelectable: true,
                },
                {
                    logo: "Chatbot",
                    title: "Chatbot",
                    isSelectable: true,
                },
                {
                    logo: "Whatsapp",
                    title: "Whatsapp",
                    isSelectable: true,
                },
                {
                    logo: "Whatsapp",
                    title: "Whatsapp Business",
                    isSelectable: true,
                },
                {
                    logo: "Instagram",
                    title: "Instagram",
                    isSelectable: true,
                },
                {
                    logo: "Messenger",
                    title: "Messenger",
                    isSelectable: true,
                },
                {
                    logo: "Binoculars",
                    title: "Önizleme",
                    isSelectable: true,
                },
                {
                    logo: "CreditCard",
                    title: "Ödeme",
                    isSelectable: true,
                },
            ],
            userAgreement: false,
        };
    },
    mounted() {
        this.initBeforeSubscribes();
        //this.initFreePlan();
    },
    methods: {
        ...mapActions({
            createPaymentMethod: "site/createPaymentMethod",
            subscribePlan: "site/subscribePlan",
            setSettingValue: "setting/setSettingValue",
            updateSettings: "setting/updateSettings",
        }),
        getPrice(plan, details, period) {
            const selectedFeatureIndex = details?.maxUsageCount
                ? plan.selectFeatures.findIndex((price) => +price.count === +details.maxUsageCount)
                : 0;

            plan.price = plan.selectFeatures?.length > 0 ? plan.selectFeatures[selectedFeatureIndex].price : plan.price;
            let price = plan.price - (plan.price * plan.couponDiscount || 0) / 100;
            let cloneDetails = _.cloneDeep(details || { agentCount: 0, whatsappChannel: 0 });
            if (plan?.isTeamPlan) cloneDetails = {};
            const discounts = {
                monthly: 0,
                "monthly-3": plan.threeMonthlyDiscount,
                "monthly-6": plan.sixMonthlyDiscount,
                annual: plan.yearlyDiscount,
                "annual-2": plan.twoYearDiscount,
                forever: 0,
            };

            let count = getProductQuantity(cloneDetails, plan.type);
            if (!count) count = getProductQuantity({}, "default");
            if (plan.isAppsumo) period = "forever";
            const discountedPrice = calcPrice(price, period, count, discounts[period]);
            if (discountedPrice) price = discountedPrice;

            return ~~price;
        },
        getDiscount(plan, details, period) {
            const selectedFeatureIndex = details?.maxUsageCount
                ? plan.selectFeatures.findIndex((price) => +price.count === +details.maxUsageCount)
                : 0;
            let price = plan.isTrialPlan ? plan.orjinalPrice : plan.price;
            price = plan.selectFeatures?.length > 0 ? plan.selectFeatures[selectedFeatureIndex].price : price;
            let cloneDetails = _.cloneDeep(details || { agentCount: 0, whatsappChannel: 0 });
            if (plan?.isTeamPlan) cloneDetails = {};
            let count = getProductQuantity(cloneDetails, plan.type);
            if (!count) count = getProductQuantity({}, "default");
            const discount = calcDiscount(price, count, period);
            if (discount) price = discount;
            return ~~price;
        },
        initBeforeSubscribes() {
            const plansHashMap = this.plans.reduce((acc, plan) => {
                acc[plan._id] = plan;
                return acc;
            }, {});
            const oldPlanActionsString = localStorage.getItem("before-current-plans") || "[]";
            let oldPlanActions = [];
            try {
                oldPlanActions = JSON.parse(oldPlanActionsString);
            } catch (e) {
                oldPlanActions = [];
            }

            const oldPlans = oldPlanActions.reduce((acc, plan) => {
                acc[plan.planType] = plansHashMap[plan.planId];
                return acc;
            }, {});

            const oldPlanActionsMap = oldPlanActions.reduce((acc, plan) => {
                acc[plan.planId] = plan;
                return acc;
            }, {});

            this.subscribes = Object.keys(this.subscribes).reduce((acc, key) => {
                const plan = oldPlans[key];
                acc[key] = this.subscribes[key];
                if (plan) {
                    const period = oldPlanActionsMap[plan._id].period;
                    const details = _.get(oldPlanActionsMap[plan._id], "details", _.get(acc[key], "details", {}));
                    const price = this.getPrice(plan, details, period);
                    const discount = this.getDiscount(plan, details, period);
                    acc[key].plan = plan;
                    acc[key].price = discount;
                    acc[key].discount = discount - price;
                    acc[key].period = period;
                    acc[key].details = details;
                }
                return acc;
            }, this.subscribes);
        },
        initFreePlan() {
            const supsisFreePlan = this.plans.find(
                (plan) => plan.isFreePlan && (plan.dynamicType || plan.type) === "supsis"
            );
            this.subscribes.supsis.details = {
                agentCount: 1,
            };
            this.subscribes.supsis.period = "monthly";
            this.subscribes.supsis.plan = supsisFreePlan;
        },
        getNextButtonText() {
            const numberToPackage = ["supsis", "chatbot", "whatsapp", "whatsapp-business"];
            let text = this.$t("billing.skipStep");
            if (this.activeIndex === 6) text = this.$t("billing.switchToPay");
            if (this.subscribes[numberToPackage[this.activeIndex]]?.plan) text = this.$t("billing.forward");
            return text;
        },
        getPeriod(type) {
            return this.subscribes[type]?.period;
        },
        getActivePlan(type) {
            return this.subscribes[type]?.plan?._id;
        },
        getPlanDetails(type) {
            return this.subscribes[type]?.details;
        },
        async setWizardAsCompleted() {
            this.disableCompleteButton = true;
            this.activeIndex = 8;
            this.updateSettings({
                ...this.settings,
                planWizardCompleted: true,
            });
            localStorage.removeItem("before-current-plans");
        },
        addSubscribe(payload, details, period) {
            const plan = this.plans.find((plan) => plan._id === payload.planId);
            const subscribe = this.subscribes[plan.type];
            if (plan.isAppsumo) subscribe.period = "forever";
            this.subscribes[plan.type].plan = {
                ...plan,
                details,
            };
            this.subscribes[plan.type].period = period;
            this.subscribes[plan.type].details = details;
            this.subscribes[plan.type].price = payload.price;
            this.subscribes[plan.type].discount = payload.discount;
        },
        removeUnSubscribe(type) {
            this.subscribes[type] = {
                ...this.subscribes[type],
                plan: null,
                price: 0,
                discount: 0,
            };
            if (type === "supsis") {
                this.initFreePlan();
            }
        },
        deletePlan(plan) {
            this.subscribes[plan.type].price = 0;
            if (["whatsapp-business", "whatsapp"].includes(plan.type)) {
                this.subscribes[plan.type].details = {
                    whatsappChannel: 1,
                };
            }
            if (plan.type == "supsis") {
                this.subscribes[plan.type].details = {
                    agentCount: 1,
                };
            }
        },
        complateWizard() {
            const { name, cardNumber, type, skt, cvv, newCardForm } = this.cardForm || {};
            const {
                name: billAdressName,
                surname,
                idenity,
                mail,
                country,
                city,
                address,
                isCompany,
                taxNumber,
                taxOffice,
            } = this.billingAddressForm || {};

            const totalPrice = Object.keys(this.subscribes).reduce((acc, sub) => {
                const plan = this.subscribes[sub];
                acc += plan.price;
                return acc;
            }, 0);

            if (
                this.sitePaymentMethod === "credit-card" &&
                totalPrice > 0 &&
                newCardForm &&
                (!name?.length || !cardNumber?.length || !type?.length || !skt?.length || !cvv?.length)
            ) {
                return message.error(this.$t("billing.pleaseFillInCard"));
            }
            if (this.sitePaymentMethod === "credit-card" && totalPrice > 0 && newCardForm && cardNumber?.length < 16) {
                return message.error(this.$t("billing.cardNumberWrong"));
            }
            if (this.sitePaymentMethod === "credit-card" && totalPrice > 0 && !this.userAgreement) {
                return message.error(this.$t("billing.pleaseConfirmTheUser"));
            }

            if (
                totalPrice > 0 &&
                (!billAdressName?.length ||
                    (!isCompany && !surname?.length) ||
                    (!isCompany && !idenity?.length) ||
                    !mail?.length ||
                    !country?.length ||
                    !city?.length ||
                    !address.length ||
                    (isCompany && !taxNumber) ||
                    (isCompany && !taxOffice))
            ) {
                return message.error(this.$t("billing.fillInTheBillingAddress"));
            }

            this.disableCompleteButton = true;
            updateBilling({
                name: billAdressName,
                surname,
                billingAddress: address,
                billingCity: city,
                billingContactName: billAdressName,
                billingCountry: country,
                email: mail,
                identityNumber: idenity,
                billingType: isCompany ? "company" : "individual",
                taxNumber: taxNumber,
                taxOffice: taxOffice,
            });

            (this.billingDetail && !newCardForm
                ? Promise.all([])
                : this.createPaymentMethod({
                      name: (name || "").split(" ")[0],
                      surname: (surname || "").split(" ")[0],
                      billingAddress: address,
                      billingCity: city,
                      billingCountry: country,
                      email: mail,
                      identityNumber: idenity,
                      taxNumber: taxNumber,
                      taxOffice: taxOffice,
                      billingContactName: billAdressName,
                      contactName: billAdressName,
                      billingType: isCompany ? "company" : "individual",
                      cardAlias: cvv,
                      cardNumber: (cardNumber || "").split(" ").join(""),
                      cardHolderName: name,
                      expireMonth: (skt || "").split("/")[0],
                      expireYear: (skt || "").split("/")[1],
                  })
            )
                .then(async (billingDetail) => {
                    billingDetail = billingDetail || this.billingDetail;
                    if (billingDetail && billingDetail.iyzicoCardToken) {
                        this.activeIndex += 1;
                    }
                    Object.keys(this.subscribes).forEach((sub) => {
                        const plan = this.subscribes[sub].plan;
                        if (plan) {
                            let payload = { planId: plan._id, period: this.subscribes[sub].period };
                            if (["supsis", "whatsapp", "whatsapp-business", "instagram", "messenger"].includes(sub)) {
                                payload.details = this.subscribes[sub].details;
                            }
                            this.subscribePlan(payload);
                        }
                    });
                    this.setWizardAsCompleted();
                })
                .catch((err) => {
                    console.error("BillingWizard.createPaymentMethod", err);
                    this.$toasted.error(this.$t("billing.pleaseCheckYourCard"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                });
        },
        async goBillingPage() {
            this.$router.push("/settings/billing");
            await this.setSettingValue({
                setting: "planWizardCompleted",
                value: true,
            });
            sendSocketMessage("admin settings-updated", {
                siteId: this.site._id,
            });
        },
    },
    computed: {
        ...mapState({
            billingDetail: (state) => state.site.billingDetail,
            plans: (state) => state.site.plans.filter((p) => !p.isDeleted),
            site: (state) => state.site.site,
            sitePaymentMethod: (state) => state.site.site?.paymentMethod || "credit-card",
            settings: (state) => state.setting.settings,
        }),
    },
    watch: {
        plans: {
            handler() {
                this.initBeforeSubscribes();
                // this.initFreePlan();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#billing-wizard {
    position: absolute;
    width: 100%;
    min-height: 100vh;
    padding: 30px;
    display: flex;
    gap: 20px;
    z-index: 999;
    background: white;

    .stepper-slider {
        border-right: 1px solid #ebebeb;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .company-logo {
            width: 100%;
            display: flex;
            align-items: center;
            margin-left: 60px;
        }
    }

    .setup {
        width: 100%;
        .header {
            .title {
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }

            .plan-steps {
                display: flex;
                font-size: 22px;
                color: #1f1f1f;
                font-weight: 600;

                span {
                    color: #848484;
                    margin-left: 10px;
                    font-size: 16px;
                }
            }
        }

        .body {
            .package-control {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                .agent-title {
                    font-weight: bold;
                }

                .agent-content {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .slider {
                        width: 400px;
                    }

                    .counter {
                        margin-left: 5px;
                        border-radius: 14px;
                        width: 65px;
                    }
                }
            }

            .content {
                .preview {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    align-items: center;
                    gap: 15px;
                    margin-bottom: 20px;
                }

                .payment {
                    display: flex;
                    justify-content: space-evenly;
                    margin-bottom: 20px;
                    width: 100%;
                    gap: 20px;
                }

                .stepper-buttons {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;

                    .stepper-button {
                        background: #ec4b1d;
                        color: white;
                        padding: 10px 40px;
                        border-radius: 20px;
                        font-weight: bold;
                        font-size: 18px;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .general-status {
        .body {
            .invoice-payment {
                display: flex;
                justify-content: space-around;
            }
        }
    }
}

@media only screen and (max-width: 900px) {
    .stepper-slider {
        display: none !important;
    }
}
</style>
<style>
#billing-wizard {
    overflow: hidden !important;
    width: 100vw !important;
    .supsis-plans {
        width: 75vw !important;
        .p-card-content {
            height: 220px !important;
        }
    }
}
</style>
